import { render } from "./PackageDetailPage.vue?vue&type=template&id=0323590b&scoped=true"
import script from "./PackageDetailPage.vue?vue&type=script&lang=js"
export * from "./PackageDetailPage.vue?vue&type=script&lang=js"

import "./PackageDetailPage.vue?vue&type=style&index=0&id=0323590b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0323590b"]])

export default __exports__